import { useState, useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthContext } from '../authContext';
import { useMediaQuery } from '@mui/material';

import RedirectHandler from '../pages/Login/RedirectHandler'
import Login from '../pages/Login';
import ChatWrapper from '../components/ChatWrapper';
import Report from '../pages/Report';
import Database from '../pages/Database';
import Hub from '../pages/Hub';
import Category from '../pages/Category';
import AssistantConfiguration from '../pages/AssistantConfiguration';
import FeedbackForm from '../pages/FeedbackForm';
import ProtectedRoute from '../components/ProtectedRoute';
import PageWithTopo from '../components/PageWithTopo';
import PageWithTopoSelf from '../components/PageWithTopoSelf';
import Management from '../pages/Management'
import GroupManagement from '../pages/GroupManagement'
import Andre from '../pages/Andre';
import Sabesp from '../pages/Sabesp';
import SetPassword from '../pages/SetPassword';
import ForgotPassword from '../pages/ForgotPassword';

function AppRoutes() {
  const {
    user, assistantList, setAssistantList, level,
    email, sessionId, setSessionId, setUser, setEmail, setAccessToken, setLevel, setUserEmail,
  } = useContext(AuthContext);

  const [totalCost, setTotalCost] = useState(0);
  const [assistant, setAssistant] = useState('');

  const isMobile = useMediaQuery('(max-width: 665px)'); // 👈 detecta mobile

  return (
    <Routes>
      <Route path="/setPassword" element={<SetPassword />} />
      <Route path="/forgotPassword" element={<ForgotPassword />} />
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<RedirectHandler />} />
      <Route path="/hub" element={
        <ProtectedRoute>
          <PageWithTopo assistant={assistant} sessionId={sessionId}>
            <Hub
              setAssistant={setAssistant}
              assistantList={assistantList}
              setAssistantList={setAssistantList}
              level={level}
              user={user}
              email={email}
              sessionId={sessionId}
            />
          </PageWithTopo>
        </ProtectedRoute>
      } />

      <Route path='/management' element={
        <ProtectedRoute blockRoles={['externo']}>
            <Management />
        </ProtectedRoute>
      } />

      <Route path='/group-management' element={
        <ProtectedRoute blockRoles={['externo']} requireManager>
            <GroupManagement />
        </ProtectedRoute>
      } />

      <Route path="/automation" element={
        <ProtectedRoute>
          <PageWithTopo assistant={assistant} sessionId={sessionId}>
            <Andre
              user={user}
              sessionId={sessionId}
            />
          </PageWithTopo>
        </ProtectedRoute>
      } />
      
      <Route path="/feedback" element={
        <ProtectedRoute>
          <PageWithTopo assistant={assistant} sessionId={sessionId}>
            <FeedbackForm />
          </PageWithTopo>
        </ProtectedRoute>
      } />

      <Route path="/assistantConfiguration" element={
        <ProtectedRoute blockRoles={['externo']}>
          <PageWithTopoSelf assistant={assistant} sessionId={sessionId}>
            <AssistantConfiguration />
          </PageWithTopoSelf>
        </ProtectedRoute>
      } />

      <Route path="/siteAssist" element={
        <ProtectedRoute>
          <ChatWrapper
            totalCost={totalCost}
            setTotalCost={setTotalCost}
            sessionId={sessionId}
            setSessionId={setSessionId}
            user={user}
            assistant={assistant}
          />
        </ProtectedRoute>
      } />

      <Route path="/report" element={
        <ProtectedRoute>
          <PageWithTopo assistant={assistant} sessionId={sessionId}>
            <Report
              totalCost={totalCost}
              setTotalCost={setTotalCost}
              sessionId={sessionId}
              setSessionId={setSessionId}
              user={user}
              assistant={assistant}
            />
          </PageWithTopo>
        </ProtectedRoute>
      } />

      <Route path="/database" element={
        <ProtectedRoute>
          <PageWithTopo assistant={assistant}>
            <Database user={user} assistant={assistant} />
          </PageWithTopo>
        </ProtectedRoute>
      } />

      <Route path="/category" element={
        <ProtectedRoute>
          <PageWithTopo assistant={assistant} sessionId={sessionId}>
            <Category
              user={user}
              sessionId={sessionId}
              totalCost={totalCost}
              setTotalCost={setTotalCost}
              setAssistant={setAssistant}
            />
          </PageWithTopo>
        </ProtectedRoute>
      } />

      <Route path="/sabesp" element={
        <ProtectedRoute>
          <PageWithTopo assistant={assistant || "Assistente NTS"} sessionId={sessionId}>
            <Sabesp />
          </PageWithTopo>
        </ProtectedRoute>
      } />

      {/* Redirecionamento padrão */}
      <Route
        path="*"
        element={
          user ?
            <Navigate to="/siteAssist" /> :
            <Navigate to="/" />
        }
      />
    </Routes>
  );
}

export default AppRoutes;
